import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoginAuth {
  requesting: boolean;
  error: any;
  data: any;
  success: boolean;
}

interface AuthState {
  loggedIn: boolean;
  authUser: any;
  loginAuth: LoginAuth;
}

const initialState: AuthState = {
  loggedIn: false,
  authUser: null,
  loginAuth: {
    requesting: false,
    error: null,
    data: null,
    success: false
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<any>) {
      state.loginAuth.requesting = true;
      state.loginAuth.error = null;
      state.loginAuth.data = null;
      state.loginAuth.success = false;
    },
    loginPerformer(state, action: PayloadAction<any>) {
      state.loginAuth.requesting = true;
      state.loginAuth.error = null;
      state.loginAuth.data = null;
      state.loginAuth.success = false;
    },
    loginSocial(state, action: PayloadAction<{ token: string; redirect: string }>) {
      state.loginAuth.requesting = true;
      state.loginAuth.error = null;
      state.loginAuth.data = null;
      state.loginAuth.success = false;
    },
    loginSuccess(state, action: PayloadAction<any>) {
      state.loggedIn = true;
      state.loginAuth.requesting = false;
      state.loginAuth.error = null;
      state.loginAuth.data = action.payload;
      state.loginAuth.success = true;
    },
    loginFail(state, action: PayloadAction<any>) {
      state.loggedIn = false;
      state.loginAuth.requesting = false;
      state.loginAuth.error = action.payload;
      state.loginAuth.success = false;
    },
    logout(state) {
      return initialState;
    }
  }
});

export const {
  login,
  loginPerformer,
  loginSocial,
  loginSuccess,
  loginFail,
  logout
} = authSlice.actions;

export default authSlice.reducer;